import { Navigate } from 'react-router-dom';

/** Administrators are managed under Settings → Administrators. */
export default function AcademyAdminManagement() {
  return <Navigate to="/settings?tab=administrators" replace />;
}
